<template>
  <div>
    <div id="sq-ccbox" class="mb-8">
      <form id="nonce-form" novalidate method="post">
        <div class="errorbox">
          <div class="error" v-for="error in errors" :key="error.message">
            {{ error }}
          </div>
        </div>
        <div id="card-container">

        </div>
        <base-button-success
            @click="requestCardNonce"
            class="ml-3 my-8 sm:ml-2 sm:my-0"
        >Pay Now</base-button-success
        >
      </form>
    </div>
  </div>
</template>

<script>
import BaseButtonSuccess from "@/components/ui/buttons/BaseButtonSuccess";
export default {
  name: "CreditCard",
  components: { BaseButtonSuccess },
  props: {
    showPaymentForm: Boolean,
    id: Number,
  },
  data() {
    return {
      errors: [],
      initialized: false,
      buttonDisabled: false,
      card: null,
    };
  },
  watch: {
    showPaymentForm: function () {
      if (!this.showPaymentForm) {
        return 1;
      }
      this.init();
    },
  },
  methods: {
    requestCardNonce: async function () {
      this.buttonDisabled = true;
      const tokenResult = await this.card.tokenize();
      if (tokenResult.status !== 'OK') {
        let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
        if (tokenResult.errors) {
          errorMessage += ` and errors: ${JSON.stringify(
              tokenResult.errors
          )}`;
        }
        throw new Error(errorMessage);
      }
      this.$emit("charge", tokenResult.token);
    },

    init: async function () {
      const applicationId = process.env.VUE_APP_SQUARE_APPLICATION;
      const locationId = process.env.VUE_APP_SQUARE_LOCATION;
      const payments = window.Square.payments(applicationId, locationId);
      this.card = await payments.card();
      await this.card.attach('#card-container');
    },
  },
  mounted: function () {
    const tag = document.createElement("script");
    tag.setAttribute("type", "text/javascript");
    tag.setAttribute("src", process.env.VUE_APP_SQUARE_ENDPOINT);
    document.head.appendChild(tag);
  },
};
</script>
<style scoped>
.disabled-button {
  background-color: gray;
  opacity: 0.7;
  cursor: default;
}
.disabled-button:hover {
  background-color: gray;
}
.sq-input ::placeholder {
  color: #aab7c4;
  opacity: 0.5;
}
.sq-input--error {
  outline: 3px auto rgb(255, 97, 97);
}
.errorbox {
  line-height: 14px;
  text-align: left;
  padding: 10px 12px;
}
.error {
  font-size: 14px;
  color: rgb(164, 0, 30);
  width: 45%;
  display: inline-block;
  margin-top: -10px;
  font-weight: 400;
  line-height: 20px;
}
#sq-ccbox {
  height: 250px;
}
</style>
